export const ValidationType = {
  InvalidToken: 0,
  InvalidSpin: 1,
  MoneyTransactionError: 2,
  NotEnoughMoney: 3,
  InvalidOperation: 4,
  SpinNotFound: 5,
  InvalidSpinCount: 6,
  InvalidAmount: 7,
  BuyBonusDisabled: 8,
  PartnerNotFound: 9,
  Success: 10,
  BonusNotFound: 11,
  InvalidSpinResult: 12,
  BonusAlreadyExists: 13,
  PlayerLimitExceeded: 14,
  InvalidRange: 15,
  InvalidIndex: 16,
  InvalidData: 17,
  InvalidSpinData: 18,
  MaxBetLimit: 22,
};

export const ResponseTypeForGamesByRound = {
  Success: 'Success',
  GeneralError: 'GeneralError',
  InValidMinBet: 'InValidMinBet',
  InValidMaxBet: 'InValidMaxBet',
  InvalidBet: 'InvalidBet',
  InsufficientFunds: 'InsufficientFunds',
  MoneyTransactionError: 'MoneyTransactionError',
  UnAuthorizedUser: 'UnAuthorizedUser',
  InvalidBetTime: 'InvalidBetTime',
  InvalidRoundId: 'InvalidRoundId',
  InValidBetData: 'InValidBetData',
  InValidToken: 'InValidToken',
  FreeBetError: 'FreeBetError',
  ResultNotFound: 'ResultNotFound',
  BetsCountExceeded: 'BetsCountExceeded',
  InvalidFreeBetData: 'InvalidFreeBetData',
  InvalidFreeBetMaxOdd: 'InvalidFreeBetMaxOdd',
  InvalidFreeBetMinOdd: 'InvalidFreeBetMinOdd',
  LimitsNotFound: 'LimitsNotFound',
  PartnerGameConfigNotFound: 'PartnerGameConfigNotFound',
  PlayerLimitExceeded: 'PlayerLimitExceeded',
  InValidAutoCashOutOdd: 'InValidAutoCashOutOdd',
  NotEnoughBalance: 'NotEnoughBalance',
  MaxBetLimit: 'MaxBetLimit',
};
